"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _useOurTranslation = require("../../utils/useOurTranslation");

var _IntroText = _interopRequireDefault(require("../IntroText"));

var _Mail = _interopRequireDefault(require("@material-ui/icons/Mail"));

var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));

var _OutlinedInput = _interopRequireDefault(require("@material-ui/core/OutlinedInput"));

var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));

var _Visibility = _interopRequireDefault(require("@material-ui/icons/Visibility"));

var _VisibilityOff = _interopRequireDefault(require("@material-ui/icons/VisibilityOff"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _ProfileProvider = require("../../provider/ProfileProvider");

var _Button = _interopRequireDefault(require("@jobmatchme/ui/es/components/styleguide/Button"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Separator = _interopRequireDefault(require("@jobmatchme/ui/es/components/Separator"));

var _validators = _interopRequireDefault(require("@jobmatchme/ui/es/utils/validators"));

var _SocialLogin = _interopRequireDefault(require("../SocialLogin"));

var _Funnel = require("../Funnel");

var _notistack = require("notistack");

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _utils = require("@jobmatchme/ui/es/components/styleguide/LanguageSelector/utils");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var anchorOrigin = {
  vertical: 'top',
  horizontal: 'right'
};

var SignUp = function SignUp(_ref) {
  var config = _ref.config;

  var _useFunnelActions = (0, _Funnel.useFunnelActions)(),
      next = _useFunnelActions.next;

  var t = (0, _useOurTranslation.useComponentTranslation)(config);

  var _useContext = (0, _react.useContext)(_ProfileProvider.ProfileActionsContext),
      setValue = _useContext.setValue,
      track = _useContext.track;

  var context = (0, _react.useContext)(_ProfileProvider.ProfileContext);

  var _useSnackbar = (0, _notistack.useSnackbar)(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar;

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loadingState = _useState2[0],
      setLoadingState = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      passwordIsInvalid = _useState4[0],
      setPasswordIsInvalid = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      emailIsInvalid = _useState6[0],
      setEmailIsInvalid = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      showPassword = _useState8[0],
      setShowPassword = _useState8[1];

  var _useState9 = (0, _react.useState)(''),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      password = _useState10[0],
      setPassword = _useState10[1];

  var handleClickShowPassword = function handleClickShowPassword() {
    setShowPassword(function (pwd) {
      return !pwd;
    });
  };

  var handleMouseDownPassword = function handleMouseDownPassword(event) {
    event.preventDefault();
  };

  var showTermsOfUse = function showTermsOfUse() {
    track('funnelSignupShowTermsOfUse', {
      step: config.valueName,
      discriminator: context.discriminator
    });
  };

  var setNotValidStatus = (0, _react.useCallback)(function (name, status) {
    if (name === 'email') {
      if (status !== emailIsInvalid) {
        track('funnelValidationStateChange', {
          step: config.valueName,
          discriminator: context.discriminator,
          newEmailIsValidState: !status
        });
      }

      setEmailIsInvalid(status);
    }

    if (name === 'password') {
      if (status !== passwordIsInvalid) {
        track('funnelValidationStateChange', {
          step: config.valueName,
          discriminator: context.discriminator,
          newPasswordIsValidState: !status
        });
      }

      setPasswordIsInvalid(status);
    }
  }, [setEmailIsInvalid, setPasswordIsInvalid, emailIsInvalid, passwordIsInvalid, track, config.valueName, context.discriminator]);

  var changeStatus = function changeStatus(name, eventValue) {
    if ((0, _validators.default)(name)(eventValue)) {
      if (name === 'email') {
        setValue(name, eventValue.toLowerCase().trim());
      }

      if (name === 'password') {
        setPassword(eventValue);
      }

      setNotValidStatus(name, false);
    } else {
      setNotValidStatus(name, true);
    }
  };

  var handleChange = function handleChange(event, name) {
    changeStatus(name, event.target.value);
  };

  var handleSubmit = function handleSubmit() {
    var _context$phone;

    // if the form data is correct, go to the record
    var emailAdress = context[config.valueName].value;
    emailAdress = emailAdress ? emailAdress.toLowerCase() : false;
    var userData = {
      username: emailAdress,
      email: emailAdress,
      password: password,
      attributes: {
        email: emailAdress,
        // optional
        phone_number: (_context$phone = context.phone) === null || _context$phone === void 0 ? void 0 : _context$phone.value,
        'custom:locale': (0, _utils.getLocaleFromUrl)()
      },
      validationData: [] //optional

    };
    import('@jobmatchme/amplify-tools/es/auth/Pc').then(function (_ref2) {
      var PcAuth = _ref2.PcAuth;
      PcAuth.signUp(userData).then(function (user) {
        if (user.userConfirmed) {
          return PcAuth.signIn(emailAdress, password).then(function () {
            setLoadingState('done');
            next();
            PcAuth.verifyCurrentUserAttribute('email').catch(function (e) {
              console.error('failed with error', e);
            });
          });
        }
      }).catch(function (e) {
        if (e.message === 'An account with the given email already exists.') {
          enqueueSnackbar(t(config.translations.emailExists), {
            variant: 'error',
            anchorOrigin: anchorOrigin
          });
        }

        setLoadingState('error');
      });
    });
  };

  var GetButton = function GetButton() {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
      round: true,
      fullWidth: true,
      variant: "contained",
      color: "success",
      disabled: emailIsInvalid || passwordIsInvalid || password === '',
      onClick: function onClick() {
        if (!emailIsInvalid && !passwordIsInvalid) {
          setLoadingState('loading');
          handleSubmit();
        }
      },
      size: "large",
      className: _styleModule.default.btnB,
      loading: {
        start: loadingState === 'loading',
        end: loadingState === 'done',
        animate: true
      },
      children: t(config.translations.submit)
    });
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IntroText.default, {
      headline: t(config.translations.text),
      text: config.translations.hint ? t(config.translations.hint) : '',
      textColor: "light"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      className: _styleModule.default.textField,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_FormControl.default, {
        variant: "outlined",
        fullWidth: true,
        className: _styleModule.default.spacing,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InputLabel.default, {
          className: _styleModule.default.label,
          htmlFor: "signUp-email",
          children: t(config.translations.inputField)
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_OutlinedInput.default, {
          error: emailIsInvalid,
          labelWidth: 70,
          id: "signUp-email",
          type: config.inputType,
          name: config.valueName,
          defaultValue: context[config.valueName].value,
          onChange: function onChange(e) {
            handleChange(e, 'email');
          },
          onBlur: function onBlur(e) {
            handleChange(e, 'email');
          },
          fullWidth: true,
          defaultInput: true,
          endAdornment: /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputAdornment.default, {
            position: "end",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Mail.default, {
              color: "primary",
              className: _styleModule.default.icon
            })
          })
        }), emailIsInvalid && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _styleModule.default.validationHelper,
          children: t(config.translations.emailHelper)
        })]
      }), (0, _ProfileProvider.isTouched)(context[config.valueName]) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_FormControl.default, {
          variant: "outlined",
          fullWidth: true,
          className: _styleModule.default.spacing,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InputLabel.default, {
            className: _styleModule.default.label,
            htmlFor: "signUp-password",
            children: t(config.translations.passwordField)
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_OutlinedInput.default, {
            variant: "outlined",
            error: passwordIsInvalid,
            labelWidth: 70,
            id: "signUp-password",
            type: showPassword ? 'text' : 'password',
            name: 'password',
            defaultValue: null,
            onChange: function onChange(e) {
              handleChange(e, 'password');
            },
            onBlur: function onBlur(e) {
              handleChange(e, 'password');
            },
            fullWidth: true,
            defaultInput: true,
            endAdornment: /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputAdornment.default, {
              position: "end",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
                "aria-label": "toggle password visibility",
                onClick: handleClickShowPassword,
                onMouseDown: handleMouseDownPassword,
                edge: "end",
                color: "primary",
                className: _styleModule.default.icon,
                children: showPassword ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Visibility.default, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_VisibilityOff.default, {})
              })
            })
          }), passwordIsInvalid && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: _styleModule.default.validationHelper,
            children: t(config.translations.passwordHelper)
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(GetButton, {})]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Separator.default, {
        mediumMargin: true,
        fullTextLine: true,
        fullTextLineText: config.translations.seperatorText ? t(config.translations.seperatorText) : ''
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SocialLogin.default, {
        variant: "rectangle",
        onLogin: next
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      className: _styleModule.default.privacy,
      children: [config.translations.privacyFirst ? t(config.translations.privacyFirst) : '', /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        href: "https://jobmatch.me/de/nutzungsbedingungen/",
        onClick: showTermsOfUse,
        className: _styleModule.default.link,
        children: config.translations.privacyLink ? t(config.translations.privacyLink) : ''
      }), "\xA0", config.translations.privacyLast ? t(config.translations.privacyLast) : '']
    })]
  });
};

var _default = /*#__PURE__*/(0, _react.memo)(SignUp);

exports.default = _default;